<script>
    export default {
       
        mounted(){
            //document.title = "EL Connect - Terms of Service"; 
            window.location.href = process.env.VUE_APP_URL_Admin_V1 +'/admin-login';
        },
    }
</script>
